import React from 'react';
import CrmContact from "../model2/crm/contact/model";

export default class CRMModalsManager {

    // type - 'account' or 'contact'
    showSearch(type, accountId, contactIds, callback) {
        gd.modal.showV4({
            className: 'modal-crm-search',
            component: require('./crm/search/search'),
            params: {
                type,
                accountId,  // for 'contact' type
                contactIds, // for 'contact' type
                onSubmit: (crmAccountId, crmContactIds)=>{
                    if (callback) callback(crmAccountId, crmContactIds);
                    gd.modal.hide();
                },
            }
        });
    }

    inviteContact(contact, callback) {
        gd.modal.showV4({
            className: 'modal-crm-invite',
            component: require('./crm/invite/invite'),
            params: {
                contact,
                onSubmit: result=>{

                    const invite = () => {
                        gd.api.CRM.inviteContact(contact.id).done(()=>{
                            if (callback) callback();
                            gd.modal.hide();
                        });
                    }

                    if (contact.email !== result.email) {
                        const crmContact = new CrmContact(contact);
                        crmContact.email = result.email;
                        crmContact.save().done(()=>{invite()});
                    } else {
                        invite()
                    }
                },
            }
        });
    }
}